<template>
      <a-modal :title="status==1?'新增项目':status==2?'详情':'编辑'" :visible="visible" width="70%" :confirm-loading="confirmLoading" cancelText="取消" okText="确定"  @ok="handleOk" @cancel="handleCancel">
            <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol"  v-if="projectDict">
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="projectName" label="项目名称" prop="projectName">
                        <a-input :disabled="disabled" v-model="form.projectName" placeholder="请输入项目名称" />
                    </a-form-model-item>
                </div>    
                <div class="maintable" style="width:50%">
                    <a-form-model-item  ref="projectType" label="类型" prop="projectType">
                        <a-select :disabled="disabled" style="width: 100%" v-model="form.projectType"  placeholder="请选择类型" @change="getCategory">
                            <a-select-option v-for="(ele,index) in projectDict.bg_project_category" :key="index" :value="ele.dict_value">{{ ele.dict_label }}</a-select-option>
                         </a-select>
                    </a-form-model-item>
                </div>  
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="projectCategory" label="类别" prop="projectCategory">
                        <a-select :disabled="disabled?true:form.projectType?false:true" style="width: 100%" v-model="form.projectCategory" placeholder="请选择类别">
                            <a-select-option v-for="(ele,index) in projectCategoryList" :key="index" :value="ele.dict_value">{{ ele.dict_label }}</a-select-option>
                         </a-select>
                    </a-form-model-item>
                </div>
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="enviroment" label="周边环境" prop="enviroment">
                        <a-select :disabled="disabled"  mode="multiple" style="width: 100%" v-model="enviromentList" @change="setenviroment" placeholder="请选择周边环境">
                         <a-select-option v-for="(ele,index) in projectDict.bg_enviroment" :key="index" :value="ele.dict_value">{{ ele.dict_label }}</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div>
                <div class="maintable" style="width:25%" >
                    <a-form-model-item :label-col="{ span:8 }" :wrapper-col="{ span: 16 }" label="市" prop="cityCode">
                         <a-select :disabled="disabled" v-model="form.cityCode" placeholder="市" @change="getCountry">
                            <a-select-option v-for="(item,index) in cityAreaList" :key="index" :value="item.code">{{ item.name }}</a-select-option>
                         </a-select>
                    </a-form-model-item>
                </div> 
                <div class="maintable" style="width:25%">
                    <a-form-model-item :label-col="{ span:8 }" :wrapper-col="{ span: 16 }" label="县/区" prop="countyCode">
                         <a-select :disabled="disabled" v-model="form.countyCode" placeholder="县/区" @change="getTowns"> 
                            <a-select-option v-for="(item,index) in countyAreaList" :key="index" :value="item.code">{{ item.name }}</a-select-option>
                         </a-select>
                    </a-form-model-item>
                </div> 
                <div class="maintable" style="width:25%">
                    <a-form-model-item :label-col="{ span:8 }" :wrapper-col="{ span: 16 }" label="乡镇/街道" prop="townCode">
                         <a-select :disabled="disabled" v-model="form.townCode" placeholder="乡镇/街道" @change="getVillage">
                           <a-select-option v-for="(item,index) in townList" :key="index" :value="item.code">{{ item.name }}</a-select-option>
                         </a-select>
                    </a-form-model-item>
                </div> 
                <div class="maintable" style="width:25%">
                    <a-form-model-item :label-col="{ span:8 }" :wrapper-col="{ span: 16 }" label="村" prop="villageCode">
                         <a-select :disabled="disabled" v-model="form.villageCode" placeholder="村" @change="getVillageName">
                            <a-select-option v-for="(item,index) in villageList" :key="index" :value="item.code">{{ item.name }}</a-select-option>
                         </a-select>
                    </a-form-model-item>
                </div>
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="houseState" label="项目状态" prop="houseState">
                        <a-select :disabled="disabled" style="width: 100%" v-model="form.houseState" placeholder="请选择项目状态">
                          <a-select-option v-for="(ele,index) in projectDict.bg_house_state" :key="index" :value="ele.dict_value">{{ ele.dict_label }}</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div>
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="restYear" label="使用年限" prop="restYear">
                        <a-input :disabled="disabled" addon-after="年" v-model="form.restYear" placeholder="请输入使用年限" />
                    </a-form-model-item>
                </div>
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="coverArea" label="占地面积" prop="coverArea">
                        <a-input :disabled="disabled" addon-after="㎡" v-model="form.coverArea" placeholder="请输入占地面积" />
                    </a-form-model-item>
                </div>
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="landArea" label="用地面积" prop="landArea">
                        <a-input :disabled="disabled" addon-after="㎡" v-model="form.landArea" placeholder="请输入用地面积" />
                    </a-form-model-item>
                </div>
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="transferor" label="出让方" prop="transferor">
                        <a-select :disabled="disabled" style="width: 100%" v-model="form.transferor" placeholder="请选择出让方">
                         <a-select-option v-for="(ele,index) in projectDict.bg_transferor" :key="index" :value="ele.dict_value">{{ ele.dict_label }}</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div>
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="authorityName" label="权利人" prop="authorityName">
                       <a-input :disabled="disabled"  v-model="form.authorityName" placeholder="请输入权利人" />
                    </a-form-model-item>
                </div>   
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="propertyYear" label="产权证" prop="propertyYear">
                        <a-select :disabled="disabled" style="width: 100%" v-model="form.propertyYear" placeholder="请选择产权证">
                          <a-select-option value="1">有</a-select-option>
                          <a-select-option value="0">无</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div>   
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="recommendOrg" label="推荐机构" prop="recommendOrg">
                        <a-select :disabled="disabled" style="width: 100%" v-model="form.recommendOrg" placeholder="请选择推荐机构">
                          <a-select-option v-for="(ele,index) in recommendOrgList" :key="index" :value="ele.orgNo">{{ ele.orgName }}</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div>   
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="mapping" label="测绘" prop="mapping">
                        <a-select :disabled="disabled" style="width: 100%" v-model="form.mapping" placeholder="请选择测绘状态">
                          <a-select-option value="1">已测绘</a-select-option>
                          <a-select-option value="0">未测绘</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div>     
                <div class="maintable" style="width:50%">
                    <a-form-model-item ref="assess" label="评估" prop="assess">
                        <a-select :disabled="disabled" style="width: 100%" v-model="form.assess" placeholder="请选择评估状态">
                          <a-select-option value="1">已评估</a-select-option>
                          <a-select-option value="0">未评估</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div> 
                <div class="maintable" style="width:50%" v-if="form.projectType == '01'">
                    <a-form-model-item ref="structure" label="结构" prop="structure">
                        <a-select :disabled="disabled" style="width: 100%" v-model="form.structure" placeholder="请选择结构">
                          <a-select-option v-for="(ele,index) in projectDict.bg_structure" :key="index" :value="ele.dict_value">{{ ele.dict_label }}</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div> 
                <div class="maintable" style="width:50%" v-if="form.projectType == '01'">
                    <a-form-model-item ref="buildArea" label="建筑面积" prop="buildArea">
                        <a-input :disabled="disabled" addon-after="㎡"  v-model="form.buildArea" placeholder="请输入建筑面积" />
                    </a-form-model-item>
                </div> 
                <div class="maintable" style="width:50%" v-if="form.projectType == '01'">
                    <a-form-model-item ref="buildYear" label="建筑年份" prop="buildYear">
                        <a-input :disabled="disabled" addon-after="年" v-model="form.buildYear" placeholder="请输入建筑年份" />
                    </a-form-model-item>
                </div> 
                <div class="maintable" style="width:50%" v-if="form.projectType == '01'">
                    <a-form-model-item ref="houseAuthority" label="经营权证" prop="houseAuthority">
                        <a-select :disabled="disabled" style="width: 100%" v-model="form.houseAuthority" placeholder="请选择经营权证">
                          <a-select-option value="1">有</a-select-option>
                          <a-select-option value="0">无</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div> 
                <div class="maintable" style="clear:both;width:100%">
                    <a-form-model-item :label-col="{ span:2 }" :wrapper-col="{ span: 22 }" ref="projectInstructions" label="项目简介" prop="projectInstructions">
                        <a-input :disabled="disabled" type="textarea" v-model="form.projectInstructions" placeholder="请输入项目简介" />
                    </a-form-model-item>
                </div> 
                <div class="maintable" style="width:100%">
                    <a-form-model-item :label-col="{ span:2 }" :wrapper-col="{ span: 22 }" ref="pictureUrl"  label="图片" prop="pictureUrl">
                        <upload :disableBool="disabled" :fileList="fileList" @changeFile="changeFile" @getFile="getFile" :id=4 ref="uploadyy"></upload>
                    </a-form-model-item>
                </div>  
                <div class="maintable" style="width:100%">
                    <a-form-model-item :label-col="{ span:2 }" :wrapper-col="{ span: 22 }" ref="videoUrl"  label="视频">
                        <uploadVideo :disableBool="disabled" :fileList="videoList" @changeFile="changeVideoFile" @getFile="getVideoFile" :id=5 ref="uploadyy"></uploadVideo>
                    </a-form-model-item>
                </div>  
                <div class="maintable" style="width:100%">
                    <a-form-model-item :label-col="{ span:2 }" :wrapper-col="{ span: 22 }" ref="fileUrl"  label="文件">
                        <uploadFile :disableBool="disabled" :fileList="lengthList" @changeFile="changeFilelength" @getFile="getFilelength" :id=6 ref="uploadyy"></uploadFile>
                    </a-form-model-item>
                </div>      
            </a-form-model>    
      </a-modal>    
</template>
<script>
import upload from '../../../components/uploadMulty.vue'
import uploadVideo  from '../../../components/uploadVideo.vue'
import uploadFile from '../../../components/uploadFile.vue'
export default {
    components:{
        upload,
        uploadVideo,
        uploadFile
    },
    data(){
        return{
            visible:false,
            confirmLoading:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            enviromentList:[],
            form:{
                projectName:'',
                projectType:undefined,  //01是农产房
                projectCategory:undefined,
                cityCode:undefined,
                cityName:'',
                countyCode:undefined,
                countyName:'',
                townCode:undefined,
                townName:'',
                villageCode:undefined,
                villageName:'',
                enviroment:'',
                landArea:'',
                houseState:undefined,
                coverArea:'',
                transferor:undefined,
                restYear:'',
                propertyYear:undefined,
                authorityName:'',
                recommendOrg:undefined,
                mapping:undefined,
                assess:undefined,
                structure:undefined,
                buildArea:'',
                buildYear:'',
                houseAuthority:undefined,
                projectInstructions:'',
                pictureUrl:'',
                videoUrl:'',
                fileUrl:''
            },
            rules:{
                 projectName: [
                    {
                        required: true,
                        message: "请输入项目名称",
                        trigger: "blur",
                    }
                ],
                projectType: [
                    {
                        required: true,
                        message: "请选择类型",
                        trigger: "change",
                    }
                ],
                projectCategory: [
                    {
                        required: true,
                        message: "请选择类别",
                        trigger: "change",
                    }
                ],
                cityCode:[
                    {
                        required: true,
                        message: "请选择市",
                        trigger: "change",
                    }
                ],
                townCode:[
                    {
                        required: true,
                        message: "请选择乡镇/街道",
                        trigger: "change",
                    }
                ],
                villageCode:[
                    {
                        required: false,
                        message: "请选择村",
                        trigger: "change",
                    }
                ],
                countyCode:[
                    {
                        required: true,
                        message: "请选择县/区",
                        trigger: "change",
                    }
                ],
                enviroment:[
                    {
                        required: true,
                        message: "请选择周边环境",
                        trigger: "change",
                    }
                ],
                houseState:[
                    {
                        required: true,
                        message: "请选择项目状态",
                        trigger: "change",
                    }   
                ],
                coverArea:[
                    {
                        required: false,
                        message: "请输入占地面积",
                        trigger: "blur",
                    },
                    {
                        pattern:/^(?:\d+(\.\d{2})?|([1-9]\d*(\.\d{1,2})?))$/,
                        message:'非负且最多保留两位小数', 
                        trigger:"blur", 
                    }
                ],
                landArea:[
                    {
                        required: true,
                        message: "请输入用地面积",
                        trigger: "blur",
                    },
                ],
                authorityName:[
                    {
                        required: true,
                        message: "请输入权利人名称",
                        trigger: "blur",
                    },
                ],
                buildArea:[
                    {
                        required: false,
                        message: "请输入建筑面积",
                        trigger: "blur",
                    },
                    {
                        pattern:/^(?:\d+(\.\d{2})?|([1-9]\d*(\.\d{1,2})?))$/,
                        message:'非负且最多保留两位小数', 
                        trigger:"blur", 
                    }
                ],
                transferor:[
                    {
                        required: true,
                        message: "请选择出让方",
                        trigger: "change",
                    }
                ],
                restYear:[
                    {
                        required: true,
                        message: "请输入剩余年份",
                        trigger: "blur",
                    },
                    {
                        pattern:/^[+]{0,1}(\d+)$/,
                        message:'请输入正整数年份', 
                        trigger:"blur", 
                    }
                ],
                propertyYear:[
                    {
                        required: true,
                        message: "请选择产权证",
                        trigger: "change",
                    }
                ],
                recommendOrg:[
                    {
                        required: true,
                        message: "请选择推荐机构",
                        trigger: "change",
                    }
                ],
                mapping:[
                    {
                        required: true,
                        message: "请选择是否测绘",
                        trigger: "change",
                    }
                ],
                assess:[
                    {
                        required: true,
                        message: "请选择是否评估",
                        trigger: "change",
                    }
                ],
                structure:[
                    {
                        required: true,
                        message: "请选择结构",
                        trigger: "change",
                    }
                ],
                buildYear:[
                     {
                        required: false,
                        message: "请输入建筑年份",
                        trigger: "change",
                    },
                    {
                        pattern:/^(18|19|20)\d{2}$/,
                        message:'请输入有效年份', 
                        trigger:"blur", 
                    }
                ],
                houseAuthority:[
                    {
                        required: true,
                        message: "请选择农房经营权证",
                        trigger: "change",
                    }
                ],
                projectInstructions:[
                    {
                        required: true,
                        message: "请输入项目简介",
                        trigger: "blur",
                    },
                ],
                pictureUrl:[
                    {
                        required: true,
                        message: "请上传图片",
                        trigger: "blur", 
                    },
                    {
                        validator:this.checkPictureUrl
                    }
                ],
            },
            projectDict:'',
            recommendOrgList:[],
            cityAreaList:[],
            countyAreaList:[],
            townList:[],
            villageList:[],
            projectCategoryList:[],
            fileList:[],
            videoList:[],
            lengthList:[],
            isEdtor:false,
            status:null,
            disabled:false
        }
    },
    created(){
        this.$https.get('/portal/projectDict/list').then(res=>{
            if(res.code == 200){
                this.projectDict = res.rows[0];
            }
        })
        this.$https.get('/project/projectDict/recommendOrgList').then(res=>{
               this.recommendOrgList = res.rows;
        })
        this.getCity()
    },
    methods:{
         getCity(){   
            let params = { code:'86' }
            this.$https.get('/portal/project/selectCityAreaList',{params:params}).then(res=>{
                 this.cityAreaList = res.rows;
                 this.form.countyCode = undefined;
                 this.form.countyName = '',
                 this.form.townCode = undefined;
                 this.form.townName = '';
                 this.form.villageCode = undefined;
                 this.form.villageName = '';
            })
        },
        getCountry(){
            this.cityAreaList.forEach(item=>{
                if(item.code == this.form.cityCode){
                    this.form.cityName = item.name
                }
            })
            let params = { code:this.form.cityCode }
       
            this.$https.get('/portal/project/selectCountyAreaList',{params:params}).then(res=>{
                 this.countyAreaList = res.rows;
                 this.form.countyCode = undefined;
                 this.form.countyName = '',
                 this.form.townCode = undefined;
                 this.form.townName = '';
                 this.form.villageCode = undefined;
                 this.form.villageName = '';
            })
        },
        getTowns(){
            this.countyAreaList.forEach(item=>{
                if(item.code == this.form.countyCode){
                    this.form.countyName = item.name
                }
            })
            let params = { code:this.form.countyCode }
            this.$https.get('/portal/project/selectTownAreaList',{params:params}).then(res=>{
                 this.townList = res.rows;
                 this.form.townCode = undefined;
                 this.form.townName = '';
                 this.form.villageCode = undefined;
                 this.form.villageName = '';
            })
        },
        getVillage(){
            this.townList.forEach(item=>{
                if(item.code == this.form.townCode){
                    this.form.townName = item.name
                }
            })
            let params = { code:this.form.townCode }
            this.$https.get('/portal/project/selectVillageAreaList',{params:params}).then(res=>{
                 this.villageList = res.rows;
                 this.form.villageCode = undefined;
                 this.form.villageName = '';
            })
        },
        getVillageName(){
            // this.$set(this.form,this.form.villageCode)
            this.villageList.forEach(item=>{
                if(item.code == this.form.villageCode){
                    this.form.villageName = item.name
                }
            })
        },
        getCategory(){
            this.$https.get(`/portal/projectDict/getListByProjectType/${this.form.projectType}`).then(res=>{
                 if(res.code == 200){
                     this.projectCategoryList = res.rows
                 }
            })
        },
        setenviroment(){
            this.form.enviroment = this.enviromentList.join(",");
        },
        showDiolag(record,status){
            this.status = status;
            this.fileList=[];
            this.videoList=[];
            this.lengthList=[];
            //1新增 2详情 3编辑
            if(status == 1){
                this.disabled = false;
                this.clear();
            }else if(status == 2){
                this.form = JSON.parse(record);
                this.disabled = true;
                this.backgetCountry();
                this.getCategory();
                this.enviromentList = this.form.enviroment.split(',');
                console.log(this.form)
             }else{
                this.form = JSON.parse(record);
                this.isEdtor = true;
                this.backgetCountry();
                this.getCategory();
                this.enviromentList = this.form.enviroment.split(',');
            }
             this.visible = true;

        },
        handleOk(e) {
            if(this.disabled){
                this.visible = false;
                return false;
            }
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if(!this.isEdtor){
                        this.confirmLoading = true;
                        this.form.enviroment = this.enviromentList.join(',');
                        this.$https.post('/portal/project/addProject',this.form).then(res=>{
                                this.confirmLoading = false;
                                if(res.code == 200){
                                    this.$message.success('保存成功');
                                    this.$emit('getDataList')
                                    this.visible = false;
                                }else{
                                    this.$message.error(res.msg);
                                }
                        }).catch(error=>{
                            this.confirmLoading = false;
                            this.$error({content:error.msg});
                        })
                    }else{
                        this.form.enviroment = this.enviromentList.join(",");
                        this.$https.post('/portal/project/editProject',this.form).then(res=>{
                                this.confirmLoading = false;
                                if(res.code == 200){
                                    this.$message.success('编辑成功');
                                    this.$emit('getDataList')
                                    this.clear();
                                    this.visible = false;
                                }else{
                                    this.confirmLoading = false;
                                    this.$message.error(res.msg);
                                }
                        }).catch(error=>{
                            this.$error({content:error.msg});
                        })  
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.visible = false;
        },
        changeFilelength(arr){
            this.lengthList = arr;
            this.form.fileUrl = JSON.stringify(this.lengthList)
        },
        getFilelength(filelist){
            this.form.fileUrl = JSON.stringify(filelist)
        },
        getVideoFile(filelist){
            let arr = [];
                filelist.forEach(item=>{
                    arr.push(item.url)
                })  
            this.form.videoUrl = arr.join(',');
        },
        changeVideoFile(arr){
            console.log(arr)
            this.videoList = arr;
            this.form.videoUrl = arr.join(',');
        },
        getFile(fileList){
            let arr = [];
                fileList.forEach(item=>{
                    arr.push(item.url)
                })  
            this.form.pictureUrl = arr.join(',');
        },
        changeFile(arr){
            console.log(arr)
            this.fileList = arr;
            this.form.pictureUrl = arr.join(',');
        },
        checkPictureUrl(rule,value,callback){
            if(this.fileList.length<8){
                callback('至少上传8张图片')
                return
            }
            callback()
        },
        clear(){
            this.form = {
                projectName:'',
                projectType:undefined,  //01是农产房
                projectCategory:undefined,
                cityCode:undefined,
                cityName:'',
                countyCode:undefined,
                countyName:'',
                townCode:undefined,
                townName:'',
                villageCode:undefined,
                villageName:'',
                enviroment:'',
                houseState:undefined,
                coverArea:'',
                transferor:undefined,
                restYear:'',
                propertyYear:undefined,
                authorityName:'',
                recommendOrg:undefined,
                mapping:undefined,
                assess:undefined,
                structure:undefined,
                buildArea:'',
                buildYear:'',
                houseAuthority:undefined,
                projectInstructions:'',
                pictureUrl:'',
                videoUrl:'',
                fileUrl:''
                }
        },
        backgetCountry(){
            // this.fileList = this.form.pictureUrl.split(',');
            // this.videoList = this.form.videoUrl.split(',');
            // this.lengthList = this.form.fileUrl.split(',');
                if(this.form.pictureUrl){
                let arr1 = this.form.pictureUrl.split(',');
                    arr1.forEach((item,index)=>{
                            let obj = {
                                uid: index+1,
                                name:'图片' + (index+1),
                                status: 'done',
                                url:item,
                            }
                            this.fileList.push(obj);
                    })
                }    
                if(this.form.videoUrl){
                    let arr2 = this.form.videoUrl.split(',');
                    arr2.forEach((item,index)=>{
                        let obj = {
                            uid: index+1,
                            name:'视频' + (index+1),
                            status: 'done',
                            url:item,
                        }
                        this.videoList.push(obj);
                    })
                }
                if(this.form.fileUrl){
                    let arr3 = JSON.parse(this.form.fileUrl);
                    this.lengthList = arr3;
                }

            let params = { code:'this.form.cityCode' }
            //let params = { code:'360925' }
            this.$https.get('/portal/project/selectCountyAreaList',{params:params}).then(res=>{
                if(res.code == 200){
                    this.countyAreaList = res.rows;
                    let obj = { code:this.form.countyCode }
                    this.$https.get('/portal/project/selectTownAreaList',{params:obj}).then(res=>{
                        if(res.code == 200){
                            this.townList = res.rows;
                            let obj2 = { code:this.form.townCode }
                            this.$https.get('/portal/project/selectVillageAreaList',{params:obj2}).then(res=>{
                                this.villageList = res.rows;
                            })
                        }
                    })
                }
            })
        },
    }
}
</script>

<style>
.maintable{
    float:left;
}
.ant-modal-body{
    display: inline-block;
}
</style>